import {Avatar, Image} from 'antd'
import {getId, getType} from 'apis/model/base'
import {default as classNames} from 'classnames'
import {FollowButton} from 'components/Feed/FollowButton'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React, {useMemo} from 'react'
import {AiOutlineLink} from 'react-icons/ai'
import {BsDiamondFill, BsPersonFill} from 'react-icons/bs'
import {GiIronCross} from 'react-icons/gi'
import {IoIosEye} from 'react-icons/io'
import {Link} from 'react-router-dom'
import {getLinkToDetailRow} from 'views/AppLocals/Codi/codiHelpers'
import {AppEntities} from 'views/AppLocals/enums'
import SearchContext from 'views/Search/SearchContext'
import {SearchTypes} from 'views/Search/SearchProvider'
import {NullAsDefault, renderElse, renderIf} from 'views/Shared'
import {FlagIcon} from '../../../components/icons/FlagIcon'
import {paths} from '../../MainPage/contains'
import {getFullAddress, renderIfElse} from "../../Shared";
import {ItemInformation} from "../../AppLocals/Organization/OrganizationEntity";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import {formatDate, renderFromToTime} from "../../../helpers/datetimeHelpers";
import {RiMapPinFill, RiSignalTowerFill} from "react-icons/ri";
import getFullName from "../../../helpers/getFullName";
import {FeastStates} from "../../AppLocals/appFieldTypes";
import {PrelatesOutlineSvg} from "../../../components/Svgs/PrelatesPlaceholder";
import {SaintsOutlineSvg} from "../../../components/Svgs/SaintsPlaceholder";
import getAvatar from "../../../helpers/getAvatar";
import {BiSolidChurch} from "react-icons/bi";
import {OrgType} from "../../AppLocals/Organization/components/OrgType";
import {ExamOutlineSvg} from "../../../components/Svgs/ExamSvg";
import {FaChalkboardTeacher} from "react-icons/fa";
import dayjs from "dayjs";
import {ifThenElseMultipleConditions} from "../../../helpers/ifThenElseMultipleConditions";
import {formatSimplifyDate} from "../../../helpers/dateUtils";
import {VoteExtraAction} from "../../../components/Feed/Ask/AskContentWrapper";
import ImageLoader from "../../../components/ImageLoader";
import {Photo} from "../../../conts/imageBase64";

const EmptySpan = () => <span/>

const ResultContentLayout = ({
                                 extra = null,
                                 Wrapper = 'div',
                                 Header = NullAsDefault,
                                 Content = NullAsDefault,
                                 Footer = NullAsDefault,
                                 ContentWrapper = 'div',
                             }) => {
    return (
        <Wrapper className="w-full relative 222-222">
            <Header/>
            <ContentWrapper className="flex items-center gap-5 w-full">
                <div className="flex-1">
                    <Content/>
                </div>
                {extra}
            </ContentWrapper>
            <Footer/>
        </Wrapper>
    )
}

const renderAvatar = (item, owner) => {

    let icon
    let avatar = _.get(owner, 'avatar')

    const type = getType(item)

    const shape = [owner, type].includes(SearchTypes.ORGANIZATION)
        ? 'square'
        : 'circle'

    switch (type) {
        case AppEntities.ORGANIZATION:
            avatar = null
            break
        case AppEntities.USER:
            avatar = null
            break
        case AppEntities.COURSE:
            avatar = null
            break
        case AppEntities.ASK:
            if (_.isEmpty(avatar)) {
                avatar = _.get(item, 'overview.photo')
            }
            break
        case AppEntities.EXAMINATION:
            avatar = null
            break
        default:
            break
    }

    return renderIf(
        avatar,
        <Avatar
            shape={shape}
            icon={icon}
            src={avatar}
            className="flex flex-center background-200"
        />
    )
}

const getPathDocumentType = (documentType) => {
    const documentTypePath = _.get(documentType, 'title')
    if (!!_.get(documentType, 'parent')) {
        return [
            getPathDocumentType(_.get(documentType, 'parent')),
            documentTypePath,
        ].join(' - ')
    }
    return documentTypePath
}

const renderResultContent = (item, owner) => {
    const item_type = getType(item)
    const isItemOwner = getId(owner) === getId(item);

    const {time_open, time_close, last_enrollment_time, is_expired} = owner ?? {}

    const renderDetailLink = (item) => (
        <Link
            to={getLinkToDetail(item)}
            className="font-bold text-sm md:text-lg text-color-000 no-underline leading-snug">
            {getTitle(item)}
            {renderIf(
                !!_.get(item, 'document_no'),
                <span className="font-medium text-sm text-color-400 italic ml-2">
                    {`(${_.get(item, 'document_no')})`}
                </span>
            )}
        </Link>
    )

    const renderIdname = (item) =>
        renderIf(
            !!item?.idname || !!item?.username,
            <div className="italic text-xs text-color-400 leading-tight max-lines-1">
                {item?.idname || item?.username}
            </div>
        )
    const renderTitle = (title) =>
        renderIf(
            !!title,
            <div className="italic text-xs text-color-400 leading-tight max-lines-1">
                {title}
            </div>
        )

    const category = _.get(item, 'categories', _.get(owner, 'categories', []))

    const mentions = Array.from(owner?.mentions ?? [])

    switch (item_type) {
        case AppEntities.EXAMINATION:
            return (
                <ResultContentLayout
                    Header={() => (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <div className="flex items-center gap-3 mb-1">
                                            <Avatar
                                                size={isSm ? 30 : 40}
                                                src={getAvatar(owner)}
                                                icon={<ExamOutlineSvg size={isSm ? 16 : 20} className="text-color-500"/>}
                                                className="flex flex-center background-200 rounded-md"
                                            />
                                            <div className="flex flex-col flex-1">
                                                {renderDetailLink(item)}
                                                <div className="space-x-1 text-xs italic">
                                                    <span className="text-color-500 whitespace-no-wrap">{t('organized by')}</span>
                                                    <Link
                                                        to={getLinkToDetail(owner)}
                                                        className="font-bold text-blue-500 no-underline">
                                                        {getTitle(owner)}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )}
                    Content={() => (
                        <Translate>
                            {(t) => (
                                <div className="flex flex-col">
                                    {renderIf(
                                        _.some([time_open, time_close]),
                                        <ItemInformation
                                            showIcon={true}
                                            label="time takes place"
                                            value={renderFromToTime(time_open, time_close)}
                                            className="text-xs italic"
                                        />
                                    )}
                                    <div className={classNames('text-sm italic font-semibold text-right', is_expired === true ? 'text-primary' : 'text-blue-700')}>
                                        {is_expired === true ? t('closed') : t('opening')}
                                    </div>
                                </div>
                            )}
                        </Translate>
                    )}
                    Footer={EmptySpan}
                />
            )
        case AppEntities.COURSE:
            return (
                <ResultContentLayout
                    Header={() => (
                        <Translate>
                            {(t) => (
                                <div className="flex items-center gap-3 mb-1">
                                    <Avatar
                                        size={40}
                                        src={_.get(owner, 'avatar')}
                                        icon={<FaChalkboardTeacher size={20} className="text-color-500"/>}
                                        className="flex flex-center background-200 rounded-md"
                                    />
                                    <div className="flex flex-col flex-1">
                                        {renderDetailLink(item)}
                                        <div className="space-x-1 text-xs italic">
                                            <span className="text-color-500 whitespace-no-wrap">{t('organized by')}</span>
                                            <Link
                                                to={getLinkToDetail(owner)}
                                                className="font-bold text-blue-500 no-underline">
                                                {_.get(owner, 'title')}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Translate>
                    )}
                    Content={() => (
                        <Translate>
                            {(t) => (
                                <div style={{ marginTop: 3 }} className="flex flex-col">
                                    {renderIf(
                                        _.some([item?.academic_field, item?.academic_year]),
                                        <span style={{ padding: '2px 8px', fontSize: '0.7rem', borderRadius: 999 }}
                                              className="w-fit border border-primary-300 font-medium text-primary-600 italic leading-tight">
                                            {renderIfElse(
                                                item?.academic_field && item?.academic_year,
                                                `${item?.academic_field} - ${item?.academic_year}`,
                                                item?.academic_field || item?.academic_year
                                            )}
                                        </span>
                                    )}
                                    {renderIf(
                                        _.some([time_open, time_close]),
                                        <ItemInformation
                                            showIcon={true}
                                            label="time"
                                            value={renderFromToTime(time_open, time_close)}
                                            className="text-xs italic"
                                        />
                                    )}
                                    {renderIf(
                                        last_enrollment_time,
                                        <ItemInformation
                                            showIcon={true}
                                            label="last enrollment time"
                                            value={formatDate(last_enrollment_time, 'DD/MM/YYYY')}
                                            className="text-xs italic"
                                        />
                                    )}
                                    <div className={classNames('text-xs italic font-semibold text-right', is_expired === true ? 'text-primary' : 'text-blue-600')}>
                                        {is_expired === true ? t('closed') : t('opening')}
                                    </div>
                                </div>
                            )}
                        </Translate>
                    )}
                    Footer={EmptySpan}
                />
            )
        case AppEntities.KEYWORD:
            return (
                <ResultContentLayout
                    Header={() => (
                        <Link
                            to={getLinkToDetail(item)}
                            className="font-bold text-base text-color-000 leading-tight no-underline 111-111">
                            {_.get(item, 'title')}
                        </Link>
                    )}
                    Content={() => (
                        <div className="flex flex-col gap-1">
                            <span className="text-sm text-color-400 tracking-wider">
                                {item?.description}
                            </span>
                            {_.get(item, 'keyword_refs', []).map((e, i) => (
                                _.get(e, 'owner') && (
                                    <Link
                                        className="space-x-1 text-color-400 hover:text-primary"
                                        to={getLinkToDetail(_.get(e, 'owner'))}
                                        key={i}>
                                        <AiOutlineLink size={9}/>
                                        <span className="text-sm italic">{getTitle(_.get(e, 'owner'))}</span>
                                    </Link>
                                )
                            ))}
                        </div>
                    )}
                />
            )
        case AppEntities.CODI_DOCUMENT_ROW:
            return (
                <Translate>
                    {(t) => (
                        <ResultContentLayout
                            Header={() => (
                                <div className="flex items-center justify-between gap-3 mb-1">
                                    {item?.id}
                                </div>
                            )}
                            Content={() => (
                                <div className="flex flex-col gap-1">
                                    <div className="flex flex-col gap-1">
                                        <Link
                                            to={getLinkToDetailRow(item)}
                                            className="font-bold text-sm md:text-lg text-color-000 no-underline">
                                            {getTitle(item)}
                                        </Link>
                                    </div>
                                </div>
                            )}
                            Footer={EmptySpan}
                        />
                    )}
                </Translate>
            )
        case AppEntities.DOCUMENT:
            return (
                <Translate>
                    {(t) => (
                        <ResultContentLayout
                            Header={() => (
                                <div className="flex items-center justify-between gap-3 mb-1">
                                    <div className="flex flex-wrap gap-2 md:gap-3">
                                        {category.map((e, i) => (
                                            <div
                                                key={i}
                                                className="flex items-center text-primary">
                                                <BsDiamondFill
                                                    size={5}
                                                    className="mr-1"
                                                />
                                                <Link
                                                    to={
                                                        paths.categoryPath
                                                            .replace(':category', e.id)
                                                    }
                                                    key={e.id}
                                                    className="italic font-medium text-xs">
                                                    {e.name}
                                                </Link>
                                            </div>
                                        ))}
                                    </div>
                                    {(_.get(item, 'language') || _.get(owner, 'language')) !==
                                    'vi' && (
                                        <FlagIcon
                                            type={_.get(item, 'language') || _.get(owner, 'language')}
                                            style={{width: '1.4em', height: '1.4em'}}
                                        />
                                    )}
                                </div>
                            )}
                            Content={() => {
                                const publish_date = _.get(
                                    item,
                                    'published_date',
                                    _.get(owner, 'published_date')
                                )
                                return (
                                    <div className="flex flex-col gap-1">
                                        {renderDetailLink(item)}
                                        <div className="grid grid-col-1 md:grid-cols-3 items-center gap-1 mt-1">
                                            {_.get(item, 'document_no') && (
                                                <div className="flex gap-2 text-xs italic leading-tight">
                          <span className="text-color-400 font-light">
                            {t('document no')}
                              {':'}
                          </span>
                                                    <span className="text-color-000 font-semibold">
                            {_.get(item, 'document_no')}
                          </span>
                                                </div>
                                            )}
                                            {publish_date && (
                                                <div className="flex gap-2 text-xs italic leading-tight">
                          <span className="text-color-400 font-light">
                            {t('published date')}
                              {':'}
                          </span>
                                                    <span className="text-color-100 font-semibold">
                            {dayjs(publish_date).format('DD/MM/YYYY')}
                          </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )
                            }}
                            Footer={EmptySpan}
                        />
                    )}
                </Translate>
            )
        case AppEntities.CODI_DOCUMENT:
            return (
                <Translate>
                    {(t) => (
                        <ResultContentLayout
                            Header={() => (
                                renderIf(
                                    _.get(item, 'language', _.get(owner, 'language')) !== 'vi',
                                    <Avatar
                                        className="flex flex-center background-100 absolute bottom-5 right-5">
                                            <span className="font-bold text-primary uppercase">
                                                {_.get(owner, 'language')}
                                            </span>
                                    </Avatar>
                                )
                            )}
                            Content={() => (
                                <div className="flex flex-col gap-1">
                                    {category.length > 0 && (
                                        <div className="flex flex-wrap flex-1 gap-1 md:gap-3">
                                            {category.map((e, index) => (
                                                <div
                                                    key={index}
                                                    className="flex items-center text-primary">
                                                    <GiIronCross
                                                        size={8}
                                                        className="mr-1"
                                                    />
                                                    <Link
                                                        to={
                                                            paths.categoryPath
                                                                .replace(':category', e.id)
                                                        }
                                                        key={e.id}
                                                        className="italic font-medium text-xs">
                                                        {e.name}
                                                    </Link>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                    {renderDetailLink(item)}
                                    {renderIf(
                                        _.get(item, 'document_type', _.get(owner, 'document_type')) ||
                                        _.get(item, 'total_views', _.get(owner, 'total_views')),
                                        <div className="flex items-center gap-3">
                                            {renderIfElse(
                                                _.get(item, 'document_type'),
                                                <span style={{ padding: '3px 10px', borderRadius: '0 15px 15px 13px' }}
                                                      className="w-fit text-2xs font-medium bg-primary-50 text-primary italic">
                                                    {getPathDocumentType(_.get(item, 'document_type'))}
                                                </span>,
                                                <span className="bg-primary-50 text-2xs text-primary font-medium italic"
                                                      style={{ padding: '3px 10px', borderRadius: '0 15px 15px 13px' }}>
                                                    {getTitle(_.get(owner, 'document_type'))}
                                                </span>
                                            )}
                                            {renderIf(
                                                _.get(item, 'total_views', _.get(owner, 'total_views')),
                                                <span style={{padding: '3px 10px'}}
                                                      className="flex items-center gap-1 text-2xs text-color-300 italic background-200 rounded-full">
                                                    <span className="leading-tight">
                                                        {Number(_.get(item, 'total_views', _.get(owner, 'total_views'))).toLocaleString()}
                                                    </span>
                                                    <IoIosEye size={13} className="text-color-300" />
                                                </span>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                            Footer={EmptySpan}
                        />
                    )}
                </Translate>
            )
        case AppEntities.ASK:
            return (
                <Translate>
                    {(t) => (
                        <div className="flex items-center gap-3">
                            <VoteExtraAction
                                item={owner}
                                canVote={false}
                                vote_status={_.get(owner, 'vote_status')}
                                total_votes={_.get(owner, 'total_votes') || 0}
                                total_downvotes={_.get(owner, 'total_downvotes') || 0}
                            />
                            <div className="flex flex-col flex-1">
                                <Link
                                    to={getLinkToDetail(owner)}
                                    className="font-semibold leading-tight text-color-000 max-lines-1 no-underline mb-1">
                                    {_.get(owner, 'title')}
                                </Link>
                                <div className="flex items-center gap-4 mb-2">
                                    <div className="flex items-center gap-1 text-xs">
                                        <span className="font-medium">{_.get(owner, 'total_views')}</span>
                                        <span className="italic text-color-400">
                                            {t('total views')}
                                        </span>
                                    </div>
                                    <div className="flex items-center gap-1 text-xs">
                                        <span className="font-medium">{_.get(owner, 'total_comments')}</span>
                                        <span className="text-xs italic text-color-400">
                                            {t('total comments')}
                                        </span>
                                    </div>
                                </div>
                                <div className="flex items-center gap-1 text-2xs italic">
                                    <span className="text-color-400">{t('posted on the channel')}</span>
                                    <Link
                                        to={getLinkToDetail(_.get(owner, 'container'))}
                                        className="font-medium no-underline text-primary flex-1">
                                        {_.get(owner, 'container.title')}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    )}
                </Translate>
            )
        case AppEntities.ARTICLE:
            return (
                <Translate>
                    {(t) => (
                        <ResultContentLayout
                            Header={() => (
                                <div className="flex items-center gap-2">
                                    <Avatar
                                        size={30}
                                        icon={<BsPersonFill size={14} className="text-color-500"/>}
                                        src={getAvatar(owner?.creator)}
                                        className="flex flex-center background-200"
                                    />
                                    <div className="flex flex-col flex-1">
                                        <div className="flex items-baseline gap-1 leading-tight">
                                            <Link to={getLinkToDetail(owner?.creator)}
                                                  className="font-bold text-sm text-primary-900 no-underline cursor-pointer max-lines-1">
                                                {getTitle(owner?.creator)}
                                            </Link>
                                            <span className="whitespace-no-wrap text-2xs text-color-500 italic">
                                                {t('posted on channel')}
                                            </span>
                                        </div>
                                        <div className="flex items-baseline gap-1 text-xs italic leading-tight">
                                            <Link to={getLinkToDetail(owner?.container)}
                                                  className="font-medium text-sm text-blue-500 no-underline max-lines-1 cursor-pointer">
                                                {getTitle(owner?.container)}
                                            </Link>
                                            {' - '}
                                            <span className="text-2xs text-color-400 whitespace-no-wrap tracking-wide">
                                                {formatSimplifyDate(owner?.created, 'fullTime')}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                            Content={() => (
                                <div className="ml-1 mt-3 flex flex-col gap-1">
                                    <Link to={getLinkToDetail(owner)} className="font-bold text-color-000 no-underline leading-snug">
                                        {getTitle(owner)}
                                    </Link>
                                    <div className="w-full flex gap-2 lg:gap-3">
                                        {!_.isEmpty(owner?.description) && (
                                            <div style={{lineHeight: 1.8}} className="flex-1 max-lines-3 text-base text-color-300">
                                                {owner?.description}
                                            </div>
                                        )}
                                        {renderIf(
                                            owner?.cover_photo,
                                            <ImageLoader
                                                fallback={Photo}
                                                src={owner?.cover_photo}
                                                className="w-20 md:w-28 h-20 object-cover rounded-md"
                                                style={{objectPosition: "center"}}
                                            />
                                        )}
                                    </div>
                                </div>
                            )}
                            Footer={() => (
                                <span className="bg-primary-50 text-2xs text-primary font-medium italic capitalize"
                                      style={{ padding: '3px 10px', borderRadius: '1px 15px 15px 13px' }}>
                                    {t(item_type)}
                                </span>
                            )}
                        />
                    )}
                </Translate>
            )
        case AppEntities.POST:
            return (
                <Translate>
                    {(t) => (
                        <ResultContentLayout
                            Header={() => (
                                <div className="flex items-center gap-2">
                                    <Avatar
                                        size={30}
                                        icon={<BsPersonFill size={14} className="text-color-500"/>}
                                        src={getAvatar(owner?.creator)}
                                        className="flex flex-center background-200"
                                    />
                                    <div className="flex flex-col flex-1">
                                        <div className="flex items-baseline gap-1 leading-tight">
                                            <Link to={getLinkToDetail(owner?.creator)}
                                                  className="font-bold text-sm text-primary-900 no-underline cursor-pointer max-lines-1">
                                                {getTitle(owner?.creator)}
                                            </Link>
                                            <span className="whitespace-no-wrap text-2xs text-color-500 italic">
                                                {t('posted on channel')}
                                            </span>
                                        </div>
                                        <div className="flex items-baseline gap-1 text-xs italic leading-tight">
                                            <Link to={getLinkToDetail(owner?.container)}
                                                  className="font-medium text-sm text-blue-500 no-underline max-lines-1 cursor-pointer">
                                                {getTitle(owner?.container)}
                                            </Link>
                                            {' - '}
                                            <span className="text-2xs text-color-400 whitespace-no-wrap tracking-wide">
                                                {formatSimplifyDate(owner?.created, 'fullTime')}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                            Content={() => (
                                <div className="flex flex-col my-2">
                                    <Link
                                        to={getLinkToDetail(owner)}
                                        className="text-sm no-underline leading-snug max-lines-3">
                                        {_.get(owner, 'overview.description')}
                                    </Link>
                                </div>
                            )}
                            Footer={() => (
                                <span className="bg-primary-50 text-2xs text-primary font-medium italic capitalize"
                                      style={{ padding: '3px 10px', borderRadius: '1px 15px 15px 13px' }}>
                                    {t(item_type)}
                                </span>
                            )}
                        />
                    )}
                </Translate>
            )
        case AppEntities.CHURCH:
            return (
                <Translate>
                    {(t) => (
                        <ResultContentLayout
                            Header={() => (
                                <span
                                    className="bg-primary-50 text-2xs text-primary font-medium italic"
                                    style={{
                                        padding: '3px 10px',
                                        borderRadius: '13px 15px 15px 0',
                                    }}>
                                  {t(item_type)}
                              </span>
                            )}
                            Content={() => (
                                <div className="flex flex-col my-1">
                                    <Link
                                        to={getLinkToDetail(owner)}
                                        className="font-bold text-sm md:text-lg text-color-000 no-underline leading-snug">
                                        {getTitle(owner)}
                                    </Link>
                                    {renderIf(
                                        getFullAddress(owner),
                                        <div className="text-sm md:text-xs text-color-500 italic max-lines-1">
                                            <RiMapPinFill size={11} className="mr-1 text-color-400"/>
                                            {getFullAddress(owner)}
                                        </div>
                                    )}
                                </div>
                            )}
                        />
                    )}
                </Translate>
            )
        case AppEntities.PARISH:
            return (
                <Translate>
                    {(t) => (
                        <ResultContentLayout
                            Header={() => (
                                <span
                                    className="bg-primary-50 text-2xs text-primary font-medium italic"
                                    style={{
                                        padding: '3px 10px',
                                        borderRadius: '13px 15px 15px 0',
                                    }}>
                                  {t(item_type)}
                              </span>
                            )}
                            Content={() => (
                                <div className="flex flex-col my-1">
                                    <Link
                                        to={getLinkToDetail(owner)}
                                        className="font-bold text-sm md:text-lg text-color-000 no-underline leading-snug">
                                        {getFullName(owner)}
                                    </Link>
                                    {renderIf(
                                        _.get(owner, 'location_address'),
                                        <div className="text-sm md:text-xs text-color-500 italic max-lines-1">
                                            <RiMapPinFill size={11} className="mr-1 text-color-400"/>
                                            {_.get(owner, 'location_address')}
                                        </div>
                                    )}
                                </div>
                            )}
                        />
                    )}
                </Translate>
            )
        case AppEntities.MUSIC:
            return (
                <Translate>
                    {(t) => (
                        <ResultContentLayout
                            Header={() => (
                                <span
                                    className="bg-primary-50 text-2xs text-primary font-medium italic"
                                    style={{
                                        padding: '3px 10px',
                                        borderRadius: '13px 15px 15px 0',
                                    }}>
                                  {t(item_type)}
                              </span>
                            )}
                            Content={() => (
                                <div className="flex flex-col my-1">
                                    <Link
                                        to={getLinkToDetail(owner)}
                                        className="font-bold text-sm md:text-lg text-color-000 no-underline leading-snug">
                                        {getTitle(owner)}
                                    </Link>
                                    {renderIf(
                                        _.get(owner, 'music_authors', []).length > 0,
                                        <div className="flex items-center gap-2 text-xs italic">
                                            <span className="text-color-500">
                                                {`${t('author')} : `}
                                            </span>
                                            {_.get(owner, 'music_authors', []).map((e, i) => (
                                                <span key={i} className="font-medium text-color-100">
                                                    {e.fullname} {i < _.get(owner, 'music_authors', []).length - 1 && ', '}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}
                        />
                    )}
                </Translate>
            )
        case AppEntities.PROFILE:
            return (
                <Translate>
                    {(t) => (
                        <ResultContentLayout
                            Header={() => (
                                <span className="bg-primary-50 text-2xs text-primary font-medium italic"
                                      style={{ padding: '3px 10px', borderRadius: '13px 15px 15px 0' }}>
                                    {renderIf(
                                        _.get(owner, 'is_martyr') === 1,
                                        t('martyr')
                                    ) || renderIf(
                                        _.get(owner, 'is_holy_doctor') === 1,
                                        t('doctor of church')
                                    ) || renderIf(
                                        _.get(owner, 'feast_state'),
                                        t(_.find(FeastStates, {value: _.get(owner, 'feast_state')})?.label)
                                    )}
                                </span>
                            )}
                            Content={() => (
                                <div className="flex items-center gap-3 mt-2">
                                    <Avatar
                                        size={36}
                                        src={_.get(owner, 'photo')}
                                        className="flex flex-center background-200"
                                        icon={
                                            renderIfElse(
                                                _.get(owner, 'profile_category_codes')?.PRELATES === true,
                                                <PrelatesOutlineSvg size={20} style={{color: '#d7d7d7'}}/>,
                                                <SaintsOutlineSvg size={20} style={{color: '#d7d7d7'}}/>
                                            )
                                        }
                                    />
                                    <div className="flex flex-col ">
                                        <Link
                                            to={getLinkToDetail(owner)}
                                            className="font-bold text-sm md:text-lg text-color-000 no-underline leading-snug">
                                            {getTitle(owner)}
                                        </Link>
                                        {renderIf(
                                            _.get(owner, 'feast_day'),
                                            <div className="flex items-center gap-2 text-xs leading-tight tracking-wider">
                                            <span className="text-color-500 whitespace-no-wrap italic">
                                                {`${t('feast day')} : `}
                                            </span>
                                                <span className="font-bold text-color-100">
                                                {_.get(owner, 'feast_day')}
                                            </span>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        />
                    )}
                </Translate>
            )
        case AppEntities.ORGANIZATION:
            return (
                <Translate>
                    {(t) => (
                        <ResultContentLayout
                            Content={() => (
                                <div className="flex items-center gap-3">
                                    <Avatar
                                        size={36}
                                        src={getAvatar(owner)}
                                        icon={<BiSolidChurch size={20} className="text-primary-300" />}
                                        className="flex flex-center bg-primary-50 rounded-md 222-222"
                                    />
                                    <div className="flex flex-col ">
                                        <Link
                                            to={getLinkToDetail(owner)}
                                            className="font-bold text-sm md:text-lg text-color-000 no-underline leading-snug">
                                            {getTitle(owner)}
                                        </Link>
                                        <OrgType item={owner} className="font-medium text-xs text-blue-500 italic"/>
                                    </div>
                                </div>
                            )}
                        />
                    )}
                </Translate>
            )
        case AppEntities.USER:
            return (
                <Translate>
                    {(t) => (
                        <ResultContentLayout
                            Content={() => (
                                <div className="flex items-center gap-3">
                                    <Avatar
                                        size={36}
                                        src={getAvatar(owner)}
                                        icon={<BsPersonFill size={20} className="text-color-500" />}
                                        className="flex flex-center background-200"
                                    />
                                    <div className="flex flex-col ">
                                        <Link
                                            to={getLinkToDetail(owner)}
                                            className="font-bold text-sm md:text-lg text-color-000 no-underline leading-snug">
                                            {getTitle(owner)}
                                        </Link>
                                        <span className="font-medium text-xs text-blue-500 italic">
                                            {t('user')}
                                        </span>
                                    </div>
                                </div>
                            )}
                        />
                    )}
                </Translate>
            )
        case AppEntities.CHANNEL:
            return (
                <Translate>
                    {(t) => (
                        <ResultContentLayout
                            Content={() => (
                                <div className="flex items-center gap-3">
                                    <Avatar
                                        size={36}
                                        src={getAvatar(_.get(owner, 'owner'))}
                                        icon={ifThenElseMultipleConditions(
                                            <RiSignalTowerFill size={20} className="text-color-500"/>,
                                            getType(_.get(owner, 'owner')) === 'organization', <BiSolidChurch size={20} className="text-primary-400" />,
                                            getType(_.get(owner, 'owner')) === 'user', <BsPersonFill size={20} className="text-color-500" />,
                                        )}
                                        className={classNames(
                                            "flex flex-center",
                                            getType(_.get(owner, 'owner')) === 'organization' ?
                                                'bg-primary-50 rounded-md' : 'background-200 rounded-full'
                                        )}
                                    />
                                    <div className="flex flex-col flex-1">
                                        <Link
                                            to={getLinkToDetail(owner)}
                                            className="font-bold text-sm md:text-lg text-color-000 no-underline leading-snug">
                                            {getTitle(owner)}
                                        </Link>
                                        <div className="space-x-1 text-xs italic">
                                            <span className="text-color-500">
                                                {t('managed by')}
                                            </span>
                                            <span className="font-medium text-xs text-blue-500 italic">
                                                {getTitle(_.get(owner, 'owner'))}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        />
                    )}
                </Translate>
            )
        case AppEntities.EVENT:
            return (
                <Translate>
                    {(t) => (
                        <ResultContentLayout
                            Content={() => (
                                <div className="flex flex-col gap-2">
                                    <div className="flex items-center gap-3">
                                        <Avatar
                                            size={36}
                                            src={getAvatar(_.get(owner, 'owner'))}
                                            icon={ifThenElseMultipleConditions(
                                                <RiSignalTowerFill size={20} className="text-color-500"/>,
                                                getType(_.get(owner, 'owner')) === 'organization', <BiSolidChurch size={20} className="text-primary-400" />,
                                                getType(_.get(owner, 'owner')) === 'user', <BsPersonFill size={20} className="text-color-500" />,
                                            )}
                                            className={classNames(
                                                "flex flex-center",
                                                getType(_.get(owner, 'owner')) === 'organization' ?
                                                    'bg-primary-50 rounded-md' : 'background-200 rounded-full'
                                            )}
                                        />
                                        <div className="flex flex-col flex-1">
                                            <Link
                                                to={getLinkToDetail(owner)}
                                                className="font-bold text-sm md:text-lg text-color-000 no-underline leading-snug">
                                                {getTitle(owner)}
                                            </Link>
                                            <div className="space-x-1 text-xs italic">
                                                <span className="text-color-500">
                                                    {t('organized by')}
                                                </span>
                                                <span className="font-medium text-xs text-blue-500 italic">
                                                    {getTitle(_.get(owner, 'owner'))}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="flex flex-col gap-1 mt-1">
                                        <div className="flex items-center gap-x-6">
                                            <ItemInformation
                                                showIcon={true}
                                                label="type of event"
                                                value={t(_.get(owner, 'event_type'))}
                                                className="text-xs italic"
                                            />
                                            <ItemInformation
                                                showIcon={true}
                                                label="start"
                                                value={formatSimplifyDate(_.get(owner, 'time_open'), 'fullTime')}
                                                className="text-xs italic"
                                            />
                                        </div>
                                        <div className="text-color-300 tracking-wider max-lines-2">
                                            {_.get(owner, 'description')}
                                        </div>
                                    </div>
                                </div>
                            )}
                        />
                    )}
                </Translate>
            )
        default:
            if (getType(owner) === AppEntities.POST) {
                const {embed_data} = owner ?? {}
                const {title} = embed_data ?? {}
                const {photo: post_photo, title: post_title} = _.get(
                    owner,
                    'overview'
                )
                const url = getLinkToDetail(owner)
                return (
                    <ResultContentLayout
                        extra={
                            post_photo && (
                                <Image
                                    width={40}
                                    height={40}
                                    className="rounded-md object-cover"
                                    preview={false}
                                    src={post_photo}
                                />
                            )
                        }
                        Content={() => (
                            <div className="flex flex-col gap-2">
                                <Link
                                    className="font-bold text-color-000 no-underline"
                                    to={url}>
                                    {title}
                                </Link>
                                {renderTitle(_.get(owner, 'overview.description'))}
                            </div>
                        )}
                    />
                )
            } else {
                return (
                    <ResultContentLayout
                        Header={EmptySpan}
                        Content={() => (
                            <div className="">
                                {renderDetailLink(owner)}
                            </div>
                        )}
                        Footer={() => renderIfElse(isItemOwner, renderIdname(owner), renderTitle(getTitle(owner)))}
                    />
                )
            }
    }
}

const OverlayItemBanner = ({style, title, className}) => (
    <div
        style={{
            backgroundColor: '#e8f0fd',
            color: 'var(--color-primary)',
            ...(style ?? {}),
        }}
        className={classNames(
            'w-fit text-xs italic pl-5 pr-4 pl-2 py-1 leading-tight rounded-r-full font-medium',
            className
        )}>
        {title}
    </div>
)

export const ItemTemplate = ({item, owner, showBanner = false, children}) => {
    const title = useMemo(() => {
        const type = getType(item)
        let title = type
        switch (type) {
            case AppEntities.DOCUMENT:
                title = [
                    _.get(
                        item,
                        'document_type.title',
                        _.get(owner, 'document_type.title')
                    ),
                    _.get(item, 'issued_place.title'),
                ]
                    .filter((e) => !_.isEmpty(e))
                    .join(' - ')
                break
            case AppEntities.CODI_DOCUMENT:
                title = [
                    _.get(item, 'document.document_type.title'),
                    _.get(item, 'document.issued_place.title'),
                ]
                    .filter((e) => !_.isEmpty(e))
                    .join(' - ')
                break
            default:
                break
        }
    }, [item])

    return (
        <div className="w-full p-3 custom-item-render background shadow hover:shadow-md hover:scale-3xs rounded-xl relative">
            {showBanner && <OverlayItemBanner title={title}/>}
            <div>{children}</div>
        </div>
    )
}

const renderSearchResultItem = (
    {
        about,
        owner = {},
        owner_type,
        description,
        follow_status,
        total_followers,
        ...item
    },
    index
) => {
    if (!!!getId(item)) return null
    return (
        <ItemTemplate
            key={index}
            item={item}
            owner={owner}>
            <div className="flex items-center gap-3">
                {renderAvatar(item, owner)}
                <div className="flex flex-1 flex-col items-start">
                    {renderResultContent(item, owner)}
                    {renderElse(
                        _.isEmpty(owner),
                        <SearchContext.Consumer>
                            {({searchParams: {type}}) =>
                                renderElse(
                                    [
                                        SearchTypes.EXAMINATION,
                                        SearchTypes.COURSE,
                                        SearchTypes.MUSIC,
                                        SearchTypes.ORGANIZATION,
                                        SearchTypes.DOCUMENT,
                                        SearchTypes.CODI_DOCUMENT,
                                        SearchTypes.CODI_DOCUMENT_ROW,
                                        SearchTypes.ASK,
                                        SearchTypes.USER,
                                    ].includes(type),
                                    <div className="w-full text-right flex justify-end">
                                        <FollowButton
                                            size="small"
                                            item={owner}
                                        />
                                    </div>
                                )
                            }
                        </SearchContext.Consumer>
                    )}
                </div>
            </div>
        </ItemTemplate>
    )
}

export default renderSearchResultItem
